export const querySplitter = (query: string) => {
    let cookieArr = query.split('&');
    let queryObj: any = {};
    for (let i = 0; i < 3; i++) {
      let cookiePart = cookieArr[i].split(/=(.*)/s); //splits from first occurrence of "="
      queryObj[cookiePart[0]] = cookiePart[1];
    }
    console.log(queryObj);
    return queryObj;
  }

  export const sendMessageToServiceWorker = (command: string, payload: any) => {
    navigator.serviceWorker?.ready
      .then((registration) => {
        console.log('registration', registration?.active, command, payload);
        registration?.active?.postMessage({ command, payload });
      })
      .catch((error) => {
        console.error('Error getting service worker registration:', error);
      });
  };

  export const SERVICE_WORKER_MESSAGE_TYPE = {
    // CLOUDFRONT_QUERY_PARAMS_SAFARI: 'CLOUDFRONT_QUERY_PARAMS_SAFARI',
    // GCP_SEC4_QUERY_PARAMS_SAFARI: 'GCP_SEC4_QUERY_PARAMS_SAFARI',
    UPDATE_IS_SAFARI: 'UPDATE_IS_SAFARI',
    UPDATE_HEADERS: 'UPDATE_HEADERS',
  }